import { ShieldCheck } from "lucide-react";

export default function AuthLayout({ children }) {
  return (
    <div className="grid min-h-screen lg:grid-cols-[1.1fr_1fr]">
      <div className="relative hidden flex-col justify-between overflow-hidden bg-[#080E21] p-12 text-slate-300 lg:flex">
        <div className="pointer-events-none absolute -right-40 top-1/3 h-[480px] w-[480px] rounded-full border border-[#2EC4B6]/20" />
        <div className="pointer-events-none absolute -right-20 top-[40%] h-[320px] w-[320px] rounded-full border border-[#2EC4B6]/30" />
        <div className="flex items-center gap-2.5">
          <div className="grid h-9 w-9 place-items-center rounded-lg bg-[#2EC4B6] font-display text-lg font-extrabold text-[#0B132B]">A</div>
          <span className="font-display text-xl font-extrabold text-white">AJsource</span>
        </div>
        <div className="max-w-md">
          <p className="eyebrow mb-4 text-[#2EC4B6]">Evidence-first sales intelligence</p>
          <h1 className="font-display text-5xl font-extrabold leading-[1.05] tracking-tight text-white">Fewer leads.<br />Better evidence.</h1>
          <p className="mt-5 text-sm leading-relaxed text-slate-400">Research campaigns, verified buying signals and a CRM built for teams that would rather chase five real opportunities than five hundred guesses.</p>
        </div>
        <div className="flex items-center gap-2 text-xs text-slate-500"><ShieldCheck className="h-4 w-4 text-[#2EC4B6]" />Tenant-isolated workspaces · Human-approved outreach only</div>
      </div>
      <div className="flex items-center justify-center bg-background p-4">{children}</div>
    </div>
  );
}
